import { Locale } from 'date-fns';
import { LOCALES } from '../../locales/localesData';

const getLocale = (country: string, language: string): Locale | null => {
  let languageCountry = `${language}${country.toUpperCase()}`;
  if (language === 'no') {
    languageCountry = 'nb';
  }
  let localeIndex = Object.keys(LOCALES).indexOf(languageCountry);
  if (localeIndex < 0) {
    localeIndex = Object.keys(LOCALES).indexOf(language);
  }
  if (localeIndex >= 0) {
    return Object.values(LOCALES)[localeIndex] as Locale;
  }
  return null;
};

export default getLocale;
